import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

/** Compact city/ZIP fallback when GPS is denied. */
export default function SetAreaBanner({
  areaInput,
  setAreaInput,
  onSubmit,
  error,
  saving,
  visible,
}) {
  if (!visible) return null;
  return (
    <div
      className="mt-4 rounded-[12px] border border-border bg-card/80 p-4"
      data-testid="set-area-banner"
    >
      <p className="text-sm font-medium">Set your area</p>
      <p className="mt-1 text-xs text-muted-foreground">
        Location access is off. Enter a city or ZIP so we can show businesses near you — or keep browsing ranked by generosity only.
      </p>
      <form
        className="mt-3 flex flex-wrap gap-2"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <Input
          className="max-w-xs flex-1"
          placeholder="City or ZIP"
          value={areaInput}
          onChange={(e) => setAreaInput(e.target.value)}
          data-testid="set-area-input"
        />
        <Button type="submit" disabled={saving} data-testid="set-area-submit">
          {saving ? "Saving…" : "Use this area"}
        </Button>
      </form>
      {error ? <p className="mt-2 text-xs text-destructive">{error}</p> : null}
    </div>
  );
}
